// src/identity/team/types.ts
var IdentityTeamAriResourceOwner = "identity", IdentityTeamAriResourceType = "team";

export {
  IdentityTeamAriResourceOwner,
  IdentityTeamAriResourceType
};
